<template>
  <div>
    <loader :show-loader="loading"></loader>

    <div class="panel-body" v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div :class="{ 'has-danger': hasError('campaign_id') }" class="form-group" data-step="2">
            <label for="selectCampaign">Dinâmica Comercial<span class="text-danger ml-1">*</span></label>
            <select :disabled="!posterPermissions.campaign" class="form-control select2" id="selectCampaign"
                    name="campaign_id" v-model="campaign_id">
              <option :value="campaign.id" v-for="campaign in campaigns">{{ campaign.name }}</option>
            </select>
            <small class="text-danger" v-if="hasError('campaign_id')">{{ getError('campaign_id') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('paper_format_id') }"
               class="form-group"
               data-intro="Clique para escolher o tamanho do cartaz."
               data-step="3">
            <label for="selectFormat">{{ paperDescription }}<span class="text-danger ml-1">*</span></label>
            <select :disabled="!posterPermissions.format" class="form-control select2" id="selectFormat"
                    name="paper_format_id" v-model="paper_format_id">
              <option :value="format.id" v-for="format in formats">{{ format.formatted_name }}</option>
            </select>
            <small class="text-danger" v-if="hasError('paper_format_id')">
              {{ getError('paper_format_id') }}
            </small>
          </div>

          <div
            :class="{ 'has-danger': hasError('template_id') }"
            class="form-group"
            data-intro="Clique para escolher o modelo do cartaz."
            data-step="4">
            <label for="selectTemplate">{{ templateDescription }}<span class="text-danger ml-1">*</span></label>
            <select :disabled="!posterPermissions.template" class="form-control" id="selectTemplate" name="template_id"
                    v-model="template_id">
              <option :value="template.id" v-for="template in templates">{{ template.name }}</option>
            </select>
            <small class="text-danger" v-if="hasError('template_id')">{{ getError('template_id') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('theme_id') }" class="form-group">
            <label for="selectTheme">{{ themeDescription }}<span class="text-danger ml-1">*</span></label>
            <select :disabled="!posterPermissions.theme" class="form-control select2" id="selectTheme" name="theme_id"
                    v-model="theme_id">
              <option :value="theme.id" v-for="theme in themes">{{ theme.name }}</option>
            </select>
            <small class="text-danger" v-if="hasError('theme_id')">{{ getError('theme_id') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('product_code') }"
               class="form-group"
               data-step="5"
               v-if="update">
            <label>Código do Produto<span class="text-danger ml-1">*</span></label>
            <input :value="product_code" name="product_code" type="hidden">
            <v-select
              :clearable="false"
              :options="listOfProducts"
              @search="fetchSearchedProducts"
              id="selectProductCode"
              label="label"
              ref="product"
              v-model="product">
              <span slot="no-options">Nenhum produto encontrado.</span>
            </v-select>
            <small class="text-danger" v-if="hasError('product_code')">{{ getError('product_code') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('main_description') }" class="form-group" v-if="update">
            <label>Descrição Principal<span class="text-danger ml-1">*</span></label>
            <textarea
              class="form-control"
              maxlength="255"
              name="main_description"
              rows="1"
              style="resize: none;"
              v-model="mainDescription"
              v-on:focus="clearField('main_description')">
						</textarea>
            <small class="text-danger" v-if="hasError('main_description')">
              {{ getError('main_description') }}
            </small>
          </div>

          <div :class="{ 'has-danger': hasError('valid_from') }" class="form-group">
            <label>Válido de</label>
            <datepicker
              :format="'dd/MM/yyyy'"
              :language="datepickerLang"
              input-class="form-control keep-active"
              name="valid_from"
              v-model="valid_from">
            </datepicker>
            <small class="text-danger" v-if="hasError('valid_from')">{{ getError('valid_from') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('valid_until') }" class="form-group">
            <label>Válido até</label>
            <datepicker
              :format="'dd/MM/yyyy'"
              :language="datepickerLang"
              input-class="form-control keep-active"
              name="valid_until"
              v-model="valid_until">
            </datepicker>
            <small class="text-danger" v-if="hasError('valid_until')">{{ getError('valid_until') }}</small>
          </div>
        </div>

        <div class="col-6">
          <div :class="{ 'has-danger': hasError('unit_id') }" class="form-group" v-if="update">
            <label class="labels-filler">Unidade de Venda<span class="text-danger ml-1">*</span></label>
            <select class="form-control select2" id="selectUnit" name="unit_id" v-model="unit_id">
              <option :value="unit.id" v-for="unit in listOfUnits">{{ unit.name }}</option>
            </select>
            <small class="text-danger" v-if="hasError('unit_id')">{{ getError('unit_id') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('department_id') }" class="form-group" v-if="update">
            <label class="labels-filler">Departamento</label>
            <select class="form-control select2" id="selectDepartment" name="department_id" v-model="department_id">
              <option :value="unit.id" v-for="unit in listOfDepartments">{{ unit.name }}</option>
            </select>
            <small class="text-danger" v-if="hasError('department_id')">{{ getError('department_id') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('value_cash') }" class="form-group" v-if="update">
            <label>Preço<span class="text-danger ml-1">*</span></label>
            <input class="form-control" name="value_cash" type="text" v-model.lazy="value_cash" v-money="decimal"/>
            <small class="text-danger" v-if="hasError('value_cash')">{{ getError('value_cash') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('value_old') }" class="form-group" v-if="update">
            <label>Preço promocional</label>
            <input class="form-control" name="value_old" type="text" v-model.lazy="value_old" v-money="decimal"/>
            <small class="text-danger" v-if="hasError('value_old')">{{ getError('value_old') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('minor_description') }" class="form-group" v-if="update">
            <label>Descrição Secundária</label>
            <input
              class="form-control"
              name="minor_description"
              type="text"
              v-model="minorDescription"
              v-on:focus="clearField('minor_description')"/>
            <small class="text-danger" v-if="hasError('minor_description')">
              {{ getError('minor_description') }}
            </small>
          </div>

          <div :class="{ 'has-danger': hasError('value_in_cash') }" class="form-group" v-if="update">
            <label>Preço</label>
            <input class="form-control" name="value_in_cash" type="text" v-model.lazy="value_in_cash"
                   v-money="decimal"/>
            <small class="text-danger" v-if="hasError('value_in_cash')">{{ getError('value_in_cash') }}</small>
          </div>

          <div :class="{ 'has-danger': hasError('parcel') }" class="form-group" v-if="update">
            <label>Parcelas</label>
            <input class="form-control" name="parcel" type="number" v-model.lazy="parcel"/>
            <small class="text-danger" v-if="hasError('parcel')">{{ getError('parcel') }}</small>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VMoney} from 'v-money';
import vSelect from 'vue-select';
import {ptBR} from 'vuejs-datepicker/dist/locale';
import ProductService from "./services/product_service";
import SelectorService from "./services/selector_service";
export default {
  name: 'form-draft-poster',
  directives: {
    money: VMoney,
  },
  components: {
    vSelect,
  },
  props: {
    draftPoster: Object,
    subDomain: String,
    errors: Array,
    old: Array,
    update: Boolean,
    posterPermissions: Object,
  },
  created() {
    this.fetchSelectorPack(0);
  },
  mounted() {
    this.$parent.$on('loadDraftPosterData', () => {
      this.isFirstLoadOnEdit = true;
      this.setData()
    });
    if (this.draftPoster)
      (!!this.old && !!this.old._token) ? this.setOld() : this.setData();
    this.fetchUnits();
    if (!this.isMagazine) {
      this.fetchProducts();
      this.fetchDepartments();
    }
  },
  computed: {
    selectedPosters() {
      return this.$store.getters['printPosters/getSelectedPosters'];
    },
    paperDescription() {
      return (this.isMagazine) ? 'Tamanho do cartaz' : 'Tamanho';
    },
    templateDescription() {
      return (this.isMagazine) ? 'Tipo de campanha' : 'Layout Coordenada';
    },
    themeDescription() {
      return 'Campanha';
    },
    isMagazine() {
      return this.subDomain && this.subDomain === 'magazineluiza';
    },
    templates() {
      return this.state.filtered_templates;
    },
    campaigns() {
      return this.state.available_campaigns;
    },
    formats() {
      return this.state.filtered_formats;
    },
    themes() {
      return this.state.filtered_themes;
    },
    listOfProducts() {
      return this.store.products;
    },
    updatePrice: {
      get() {
        return this.$store.getters['poster/getUpdatePrice'];
      },
      set(updatePrice) {
        this.$store.commit('poster/SET_UPDATE_PRICE', updatePrice);
      },
    },
    productSelected: {
      get() {
        return this.$store.getters['poster/getSelectedProduct'];
      },
      set(productSelected) {
        this.$store.commit('poster/SET_PRODUCT', productSelected);
      },
    },
    listOfUnits: {
      get() {
        return this.store.units;
      },
      set(units) {
        this.$store.commit('product/SET_UNITS', units);
      }
    },
    listOfDepartments: {
      get() {
        return this.store.departments;
      },
      set(departments) {
        this.$store.commit('product/SET_DEPARTMENTS', departments);
      }
    },
    product_code() {
      return (!!this.product && !!this.product.code) ? this.product.code : '';
    },
    canOnlyEditFormat() {
      return this.posterPermissions.format
        && !this.posterPermissions.campaign
        && !this.posterPermissions.template
        && !this.posterPermissions.theme;
    }
  },
  watch: {
    campaign_id(campaign_id) {
      this.$store.dispatch('selector/updateFormatListByCampaignId', campaign_id);
      this.$store.dispatch('selector/updateCampaignId', campaign_id);
      if (!this.isFirstLoadOnEdit || !this.isCreate) {
        this.template_id = undefined;
        this.paper_format_id = undefined;
        this.theme_id = undefined;
      }
    },
    paper_format_id(paper_format_id) {
      if (paper_format_id) {
        const templates = this.templates || [];
        const themes = this.themes || [];
        const oldTemplate = _.get(templates.find((template) => template.id == this.template_id), 'name');
        const oldTheme = _.get(themes.find((theme) => theme.id == this.theme_id), 'name');
        this.$store.dispatch('selector/updateTemplateByPaperFormatIdAndCampaignId',
          {paper_format_id: paper_format_id, campaign_id: this.campaign_id});
        if (this.canOnlyEditFormat && oldTemplate && oldTheme) {
          this.$nextTick().then(() => {
            this.template_id = _.get(this.templates.find((template) => template.name === oldTemplate), 'id');
          }).then(() => {
            this.theme_id = _.get(this.themes.find((theme) => theme.name === oldTheme), 'id');
          })
        }
      }
    },
    template_id(template_id) {
      if (template_id) {
        if (!this.isFirstLoadOnEdit) {
          this.theme_id = undefined;
        }
        this.isCreate = false;
        this.$store.dispatch('selector/updateThemesByTemplateId', template_id);
        if (this.isMagazine && this.$store.getters['poster/getSelectedProduct'].code !== ' ') {
          this.$root.$emit('updateMagazineProduct');
        }
      }
    },
    theme_id(theme_id) {
      if (theme_id) {
        this.setThemeById(theme_id);
      }
    },
    idTheme() {
      this.themeId = this.idTheme;
    },
    templateId(templateId) {
      if (templateId) {
        this.loadTemplateFromProp();
      }
    },
  },
  data() {
    return {
      datepickerLang: ptBR,
      loading: true,
      store: this.$store.state.product,
      state: this.$store.state.selector,
      themeId: undefined,
      theme_id: undefined,
      template_id: undefined,
      campaign_id: undefined,
      paper_format_id: undefined,
      isCreate: true,
      isfirstLoadOnEdit: true,
      product: undefined,
      mainDescription: undefined,
      minorDescription: undefined,
      unit_id: undefined,
      department_id: undefined,
      value_cash: undefined,
      value_old: undefined,
      promotion_description: undefined,
      valid_from: undefined,
      valid_until: undefined,
      decimal: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    fetchSelectorPack(posterId) {
      return SelectorService.fetchSelectorPack(posterId).then((response) => {
        this.$store.commit('selector/SET_AVAILABLE_CAMPAIGNS', response.campaigns);
        this.$store.commit('selector/SET_AVAILABLE_PAPER_FORMATS', response.paper_formats);
        this.$store.commit('selector/SET_AVAILABLE_TEMPLATES', response.templates);
        this.$store.commit('selector/SET_AVAILABLE_THEMES', response.themes);
        if (this.templateId) {
          this.loadTemplateFromProp();
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    setThemeById(theme_id) {
      this.theme_id = theme_id;
      let theme = this.$store.getters['selector/getThemeById'](theme_id);
      this.$store.commit('selector/SET_THEME', theme);
    },
    loadTemplateFromProp() {
      let template = this.$store.getters['selector/getTemplateById'](this.templateId);
      if (template) {
        this.campaign_id = template.campaign_id;
        this.paper_format_id = template.paper_format_id;
        this.template_id = this.templateId;
      }
    },
    fetchProducts() {
      ProductService.fetchProducts().then((products) => {
        const productInList = products.find(product => product.id === this.productSelected.id);
        if (productInList) {
          this.productSelected.barcode = productInList.barcode || productInList.code;
          products.push(this.productSelected);
        }
        this.product = this.productSelected;
        const data = {
          products: products,
          hasSubdomain: this.isMagazine,
        };
        this.$store.commit('product/SET_PRODUCTS', data);
        return products;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    fetchSearchedProducts: _.debounce(function (query, loading) {
      this.updatePrice = true;
      ProductService.fetchProducts(query).then((products) => {
        if (!(this.isMagazine) && this.product.id == -1 && !!query)
          this.product.id = -2;
        let indexProductQuery = _.findIndex(products, function (product) {
          return product.code.toLowerCase() == query.toLowerCase();
        });
        if (!!query && indexProductQuery === -1 && !(this.isMagazine)) {
          products.unshift({label: query + ' (criar novo)', code: query, id: -1});
        }
        const data = {
          products: products,
          hasSubdomain: this.isMagazine,
        };
        this.$store.commit('product/SET_PRODUCTS', data);
        this.$store.commit('SET_ACTION', 'create');
        loading(false);
        return products;
      }).catch((error) => {
        loading(false);
        this.$root.throwFlashMessage('danger', error.message);
      });
    }, 300),
    clearField(field) {
      const value = this.$store.getters['poster/field'](field);
      if (!value || value === ' ') {
        this.$store.commit('poster/SET_FIELD_COMPOUND',
          {
            field: field,
            value: ' ',
          });
        setTimeout(() => {
          this.$store.commit('poster/SET_FIELD_COMPOUND',
            {
              field: field,
              value: '',
            });
        }, 100);
      }
    },
    fetchUnits() {
      ProductService.fetchUnits().then((units) => {
        this.$store.commit('product/SET_UNITS', units);
        return units;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    fetchDepartments() {
      ProductService.fetchDepartments().then((departments) => {
        this.$store.commit('product/SET_DEPARTMENTS', departments);
        return departments;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },
    getError(key) {
      return (this.errors && this.errors[key]) ? this.errors[key][0] : undefined;
    },
    hasError(key) {
      return (this.errors && this.errors[key]);
    },
    setOld() {
      if (this.old) {
        this.campaign_id = this.old.campaign_id;
        this.paper_format_id = this.old.paper_format_id;
        this.template_id = this.old.template_id;
        this.theme_id = this.old.theme_id;
        this.product = this.old.product_code;
        this.mainDescription = this.old.main_description;
        this.minorDescription = this.old.minor_description;
        this.unit_id = this.old.unit_id;
        this.department_id = this.old.department_id;
        this.value_cash = this.old.value_cash;
        this.value_old = this.old.value_old;
        this.promotion_description = this.old.promotion_description;
        this.valid_from = this.old.valid_from;
        this.valid_until = this.old.valid_until;
      }
    },
    setData() {
      if (this.draftPoster) {
        // this.campaign_id = this.draftPoster.campaign_id;
        // this.paper_format_id = this.draftPoster.paper_format_id;
        // this.template_id = this.draftPoster.template_id;
        // this.theme_id = this.draftPoster.theme_id;
        // this.product = this.draftPoster.product_code;
        // this.mainDescription = this.draftPoster.main_description;
        // this.minorDescription = this.draftPoster.minor_description;
        // this.unit_id = this.draftPoster.unit_id;
        // this.department_id = this.draftPoster.department_id;
        // this.value_cash = this.draftPoster.value_cash;
        // this.value_old = this.draftPoster.value_old;
        // this.promotion_description = this.draftPoster.promotion_description;
        // this.valid_from = this.draftPoster.valid_from;
        // this.valid_until = this.draftPoster.valid_until;
      }
      const vm = this;
      setTimeout(function () {
        vm.isFirstLoadOnEdit = false;
      }, 1000);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/FormDraftPoster.vue